import { Children } from 'react';

import styles from './ListControls.scss';

export default function ListControls({children}){
    const style = Children.count(children) > 2 ? styles.oops : styles.wrapper;
    return (
        <div className={style}>
            {children}
        </div>
    );
}

export function ListDropdownPanel({children}){
    return (
        <div className={styles.listDropdownPanel} data-cy="ListDropdownPanel">
            {children}
        </div>
    );
}
